export default {"src":"/_next/static/media/caret-left.ef682801.svg","height":20,"width":13};